import { useThemeContext } from '#contexts/ThemeContext';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { colors } from '@swyft/ui';
import React from 'react';
import { useBreakpoints } from '../../utils/breakpoint';

const pinelyneLink = 'https://www.pipelyne.com/';

export interface FooterProps {
  disabled?: boolean;
  handleBack?: () => void;
  isWhiteLabel?: boolean;
  showBackButton?: boolean;
}

export const Footer = ({ disabled = true, handleBack = () => null, showBackButton, isWhiteLabel }: FooterProps) => {
  const { isLessThanXs, isLessThanSm } = useBreakpoints();
  const { isEmbed, background } = useThemeContext();
  const classes = useStyles(Boolean(isEmbed), background)();

  return (
    <React.Fragment>
      {(!isWhiteLabel || showBackButton) && (
        <Box
          className={`${classes.customFooter} ${isLessThanXs && !isEmbed ? 'swyft-box-shadow-up' : ''}`}
          minHeight={isLessThanXs && isEmbed ? '8%' : '8vh'}
          mt='auto'
          pb={isLessThanXs || isEmbed ? 0 : 2}
          width='100%'
          display='flex'
          alignItems='center'
        >
          <Box
            width={isEmbed ? 'max-content' : '100%'}
            bgcolor={isEmbed && !isWhiteLabel ? colors.white : 'unset'}
            ml={isEmbed ? 'auto' : 'unset'}
            mr={isEmbed ? 2 : 'unset'}
            px={isEmbed ? 2 : 'unset'}
            py={isEmbed ? 1 : 'unset'}
            textAlign='center'
            borderRadius={isEmbed ? 'borderRadius' : 0}
          >
            {!isWhiteLabel && (
              <React.Fragment>
                <Typography
                  variant={isLessThanXs ? 'caption' : isLessThanSm ? 'subtitle2' : 'subtitle1'}
                  style={{ color: colors.grey.DEFAULT }}
                  display='inline'
                >
                  Powered by
                </Typography>
                <a
                  rel='noreferrer'
                  target='_blank'
                  href={pinelyneLink}
                  color={colors.primary.main}
                  style={{ marginLeft: '0.3rem' }}
                >
                  <Typography
                    variant={isLessThanXs ? 'caption' : isLessThanSm ? 'subtitle2' : 'subtitle1'}
                    style={{ color: colors.primary.main }}
                    display='inline'
                  >
                    Pipelyne
                  </Typography>
                </a>
              </React.Fragment>
            )}
          </Box>
        </Box>
      )}
    </React.Fragment>
  );
};

const useStyles = (isEmbed: boolean, background: string) =>
  makeStyles((theme: any) => ({
    customFooter: {
      backgroundColor: isEmbed ? background : 'unset',
      position: 'relative',
      bottom: 'unset',
      [theme.breakpoints.down('xs')]: {
        position: isEmbed ? 'sticky' : 'fixed',
        backgroundColor: isEmbed ? background : 'white',
        bottom: 0
      }
    }
  }));
